module.exports = __webpack_public_path__ + "img/youhui2.5205d2c6.png";